<header class="navbar">
  <div class="navbar-container content-wrapper">
    <div class="logo">
      <a href="/">
        <img
          src="/assets/logo/logo.avif"
          alt="Geekeno Logo"
          loading="eager"
          fetchpriority="high"
          width="295"
          height="69"
        />
      </a>
    </div>

    <button
      class="hamburger"
      [class.open]="isMobileMenuOpen"
      (click)="toggleMobileMenu()"
      [attr.aria-label]="isMobileMenuOpen ? 'Close Menu' : 'Open Menu'"
      type="button"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <nav aria-label="Primary">
      <ul
        role="menubar"
        class="nav-links"
        [class.open]="isMobileMenuOpen"
        [attr.aria-expanded]="isMobileMenuOpen"
      >
        <li role="menuitem">
          <a
            routerLink="/"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            >About</a
          >
        </li>
        <li
          role="menuitem"
          class="dropdown"
          (mouseenter)="toggleDropdown('svc', true)"
          (mouseleave)="toggleDropdown('svc', false)"
        >
          <button
            class="dropdown-btn"
            (click)="toggleDropdown('svc', !dropdownOpen.svc)"
            [class.active]="
              svcDigitalMarketing.isActive ||
              svcWebDevelopment.isActive ||
              svcGraphicDesigning.isActive ||
              svcVideoProduction.isActive
            "
            type="button"
            aria-haspopup="true"
            aria-controls="serviceMenu"
            id="serviceMenuButton"
          >
            Services <span class="arrow">▼</span>
          </button>
          <ul
            role="menu"
            class="dropdown-menu"
            [class.active]="dropdownOpen.svc"
            [attr.aria-expanded]="dropdownOpen.svc"
            id="serviceMenu"
            aria-labelledby="serviceMenuButton"
          >
            <li role="menuitem">
              <a
                routerLink="/services/digital-marketing"
                routerLinkActive="active"
                #svcDigitalMarketing="routerLinkActive"
                class="dropdown-item"
                >Digital Marketing</a
              >
            </li>
            <li role="menuitem">
              <a
                routerLink="/services/website-development"
                routerLinkActive="active"
                #svcWebDevelopment="routerLinkActive"
                class="dropdown-item"
                >Website Development</a
              >
            </li>
            <li role="menuitem">
              <a
                routerLink="/services/graphic-designing"
                routerLinkActive="active"
                #svcGraphicDesigning="routerLinkActive"
                class="dropdown-item"
                >Graphic Designing</a
              >
            </li>
            <li role="menuitem">
              <a
                routerLink="/services/video-production"
                routerLinkActive="active"
                #svcVideoProduction="routerLinkActive"
                class="dropdown-item"
                >Video Production & Editing</a
              >
            </li>
          </ul>
        </li>
        <li
          role="menuitem"
          aria-hidden="true"
          class="mobile-services is-hidden-tablet"
        >
          <p class="services-title">Services</p>
          <ul role="menu">
            <li role="menuitem">
              <a
                routerLink="/services/digital-marketing"
                routerLinkActive="active"
                class="service-item"
                >- Digital Marketing</a
              >
            </li>
            <li role="menuitem">
              <a
                routerLink="/services/website-development"
                routerLinkActive="active"
                class="service-item"
                >- Website Development</a
              >
            </li>
            <li role="menuitem">
              <a
                routerLink="/services/graphic-designing"
                routerLinkActive="active"
                class="service-item"
                >- Graphic Designing</a
              >
            </li>
            <li role="menuitem">
              <a
                routerLink="/services/video-production"
                routerLinkActive="active"
                class="service-item"
                >- Video Production & Editing</a
              >
            </li>
          </ul>
        </li>
        <li
          role="menuitem"
          class="dropdown"
          (mouseenter)="toggleDropdown('prd', true)"
          (mouseleave)="toggleDropdown('prd', false)"
        >
          <button
            class="dropdown-btn"
            (click)="toggleDropdown('prd', !dropdownOpen.prd)"
            [class.active]="prdBrandKit.isActive"
            type="button"
            aria-haspopup="true"
            aria-controls="productMenu"
            id="productMenuButton"
          >
            Products <span class="arrow">▼</span>
          </button>
          <ul
            role="menu"
            class="dropdown-menu"
            [class.active]="dropdownOpen.prd"
            [attr.aria-expanded]="dropdownOpen.prd"
            id="productMenu"
            aria-labelledby="productMenuButton"
          >
            <li role="menuitem">
              <a
                routerLink="/products/brand-kit"
                routerLinkActive="active"
                #prdBrandKit="routerLinkActive"
                class="dropdown-item"
                >Brand Kit</a
              >
            </li>
            <li role="menuitem">
              <a
                routerLink="/products/rekavoze"
                routerLinkActive="active"
                #prdBrandKit="routerLinkActive"
                class="dropdown-item"
                >Rekavoze</a
              >
            </li>
          </ul>
        </li>
        <li
          role="menuitem"
          aria-hidden="true"
          class="mobile-services is-hidden-tablet"
        >
          <p class="services-title">Products</p>
          <ul role="menu">
            <li role="menuitem">
              <a
                routerLink="/products/brand-kit"
                routerLinkActive="active"
                class="service-item"
                >- Brand Kit</a
              >
            </li>
            <li role="menuitem">
              <a
                routerLink="/products/rekavoze"
                routerLinkActive="active"
                class="service-item"
                >- Rekavoze</a
              >
            </li>
          </ul>
        </li>
        <li role="menuitem">
          <a routerLink="/blog" routerLinkActive="active">Blog</a>
        </li>
        <li role="menuitem">
          <button
            class="contact-btn is-hidden-mobile"
            (click)="openContactModal()"
          >
            Contact Us
          </button>
        </li>
      </ul>
    </nav>
  </div>
</header>
